import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HeaderHV from "./components/HeaderHV/HeaderHV";
import HomeHV from "./pages/home/HomeHV";
import ClinicWeeklySchedule from "./components/ClinicWeeklySchedule/ClinicWeeklySchedule";
import ClinicWeeklyScheduleTV from "./components/ClinicWeeklySchedule/ClinicWeeklyScheduleTV";
import ClinicWeeklySchedule7Days from "./components/ClinicWeeklySchedule/ClinicWeeklySchedule7Days/ClinicWeeklySchedule7Days";
import LiberationDay from "./pages/liberation/LiberationDay";

export default function App() {
  const { pathname } = useLocation();

  // ẨN HEADER Ở TRANG TV + TRANG 7 NGÀY + TRANG KỶ NIỆM 30/4
  const showHeader =
    pathname !== "/lich-kham-tv" &&
    pathname !== "/lich-phong-kham-7-ngay" &&
    pathname !== "/ngay-giai-phong";

  return (
    <>
      {showHeader && <HeaderHV />}
      {showHeader && <div className="hv-spacer" />}

      <Routes>
        <Route path="/" element={<HomeHV />} />
        <Route path="/lich-kham" element={<ClinicWeeklySchedule />} />
        <Route path="/lich-kham-tv" element={<ClinicWeeklyScheduleTV />} />
        <Route
          path="/lich-phong-kham-7-ngay"
          element={<ClinicWeeklySchedule7Days />}
        />
        <Route path="/ngay-giai-phong" element={<LiberationDay />} />
      </Routes>
    </>
  );
}
